import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { Slide, ToastContainer, toast } from "react-toastify";

import { LoginLayout } from "../../../layouts/Login";
import { Button } from "../../../components/Button";
import { CreateForm } from "../components/CreateForm";

import { useUserToken } from "../../../hooks/core/UserToken";
import { loginManagement } from "../../../hooks/api/LoginManagement";
import { showNotification } from "../../../slices/NotificationSlice";
import i18n from "../../../i18n";
import langLogo from '../../../assets/icons/Union.svg'

const Login = () => {
    const { t } = useTranslation("common");
    const formDefs = [
        { name: "username", label: t("username"), required: true },
        { name: "password", label: t("password"), type: "password", required: true },
    ];

    const [loginInfo, setLoginInfo] = useState({
        username: "",
        password: "",
    });
    const [rememberMe, setRememberMe] = useState(false);
    const { useLoginMutation } = loginManagement;
    const [login] = useLoginMutation();
    const [userToken] = useUserToken();
    const dispatch = useDispatch();

    const navigate = useNavigate();

    const handleErrorMessage = (response) => {
        const errorMessage = response?.error?.responseMessage || t("invalidCredentials");

        toast.error(errorMessage);
    };

    const handleSubmit = async (values) => {
        try {
            const response = await login(values)?.unwrap();
            const token = response?.token;
            if (token) {
                userToken.setItem(token, rememberMe);
                navigate("/calendar-featured/day-view");
            }

            if (response?.error) {
                handleErrorMessage(response);
            }
        } catch (error) {
            handleErrorMessage(error?.data);
        }
    };

    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
        localStorage.setItem("language", lng);
    };

    return (
        <LoginLayout>
            
            <CreateForm formDefs={formDefs} initialValues={loginInfo} onSubmit={(values) => handleSubmit(values)}>
                <div className="section-login__pass-reset">
                    <div className="input-toggle">
                        <input type="checkbox" id="toggle" checked={rememberMe} onChange={() => setRememberMe((prev) => !prev)} className="toggle-input" />
                        <label className="toggle-switch" htmlFor="toggle">
                            <span className="toggle-btn"></span>
                        </label>
                        <label htmlFor="toggle" className="toggle-label">
                            {t("rememberMe")}
                        </label>
                    </div>
                    <Link to={"/sign-up/forgotten-password"}>{t("forgotPassword")}</Link>
                </div>
                <Button type="submit">{t("login")}</Button>
                <div className="section-login__language-switch">
                    <img src={langLogo} />
                    <span className={i18n.language === "en" ? "active" : ""} onClick={() => changeLanguage("en")}>
                        EN
                    </span>
                    {" | "}
                    <span className={i18n.language === "sr" ? "active" : ""} onClick={() => changeLanguage("sr")}>
                        SR
                    </span>
                </div>
            </CreateForm>
        </LoginLayout>
    );
};

export default Login;
